import React, {Component, PropTypes} from 'react';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {Field, Toggle} from 'components/forms';
import Form from './form';
import {isConfigurationsApiEnabled} from './api';
import Configurations from './configurations';

@autobind
export default class Toolbar extends Component {
    static propTypes = {
        config: PropTypes.object.isRequired,
        mobile: PropTypes.bool.isRequired,
        toolbarOpened: PropTypes.bool.isRequired,
        disableLink: PropTypes.bool,
        disableEmbed: PropTypes.bool,
        onToggle: PropTypes.func.isRequired,
        onConfigReset: PropTypes.func,
        onConfigChange: PropTypes.func,
        getConfigValues: PropTypes.func,
        onValueChange: PropTypes.func.isRequired,
        onCodeCopy: PropTypes.func.isRequired,
    };

    state = {
        embedCodeStatus: 'get',
        shareLinkStatus: 'get',
        advancedView: false,
    };

    shouldShowConfigurations() {
        return isConfigurationsApiEnabled();
    }

    setCopyStatus(trigger, status) {
        const key = `${trigger}Status`;
        this.setState({[key]: status});
        const resetStatus = () => this.setState({[key]: 'get'});
        clearTimeout(this.resetTimeout);
        this.resetTimeout = setTimeout(resetStatus, 2500);
    }

    handleCopy(type) {
        return async () => {
            this.setCopyStatus(type, 'working');
            await this.props.onCodeCopy(type);
            this.setCopyStatus(type, 'done');
        };
    }

    handleToggleAdvancedView() {
        this.setState(state => ({
            advancedView: !state.advancedView,
        }));
    }

    renderToggle() {
        if (this.props.mobile) {
            return (
                <div className='mobile-toolbar-toggle' onClick={this.props.onToggle}>
                    <i className='cielo24-vwrap-icon cielo24-vwrap-icon-chevron-right' />
                    <span>Close Toolbar</span>
                </div>
            );
        }

        const style = {transform: `rotate(${this.props.toolbarOpened ? '0' : '180deg'})`};
        return (
            <div className='toggle' onClick={this.props.onToggle}>
                <i className='cielo24-vwrap-icon cielo24-vwrap-icon-chevron-right' style={style} />
            </div>
        );
    }

    renderCopyButton(label, type) {
        const status = this.state[`${type}Status`];
        const text = {get: `GET ${label}`, working: 'WORKING...', done: 'COPIED'}[status];
        const disabled = status === 'working';

        return (
            <button
                type='button'
                onClick={this.handleCopy(type)}
                disabled={disabled}
                className={classNames('button', 'get-code', {disabled})}
            >
                {text}
            </button>
        );
    }

    render() {
        const showLink = !this.props.disableLink;
        const showEmbed = !this.props.disableEmbed;

        return (
            <div className={classNames('toolbar', {opened: this.props.toolbarOpened})}>
                {this.renderToggle()}
                <div className='header'>
                    {this.shouldShowConfigurations() && (
                        <Configurations
                            getValues={this.props.getConfigValues}
                            onChange={this.props.onConfigChange}
                            onReset={this.props.onConfigReset}
                        />
                    )}
                    {(showEmbed || showLink) && (
                        <div className='copy-buttons'>
                            {showEmbed && this.renderCopyButton('EMBED CODE', 'embedCode')}
                            {showLink && this.renderCopyButton('SHARE LINK', 'shareLink')}
                        </div>
                    )}
                </div>
                <div className='content'>
                    <Form
                        values={this.props.config}
                        mobile={this.props.mobile}
                        onChange={this.props.onValueChange}
                        advancedView={this.state.advancedView}
                    />
                </div>
                <div className='footer'>
                    <Field label='Advanced view'>
                        <Toggle value={this.state.advancedView} onChange={this.handleToggleAdvancedView} />
                    </Field>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/test-page/toolbar.js